<div data-testid="activity-ranking" class="activity-ranking">
  <header class="activity-ranking__header">
    <div class="activity-ranking__titles">
      <h4 class="activity-ranking__title">Most and least active companies</h4>
      <p *ngIf="ranking" class="activity-ranking__description">
        <span data-testid="activity-subtitle">{{ subtitle }}</span>
        <button *ngIf="ranking.silentCount" type="button" data-testid="silent-link" class="activity-ranking__silent"
                (click)="openSilent()">{{ silentText }}</button>
      </p>
    </div>
  </header>
  <app-admin-dashboard-empty *ngIf="failed" data-testid="activity-failed" icon="fa-regular fa-circle-exclamation"
                             [title]="failedTitle" body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="loaded && !failed && !ranking?.most?.length" data-testid="activity-empty" icon="fa-regular fa-users"
                             [title]="emptyText"></app-admin-dashboard-empty>
  <div *ngIf="ranking?.most?.length" class="activity-ranking__split">
    <div class="activity-ranking__list">
      <p class="activity-ranking__label">Most active</p>
      <button *ngFor="let row of ranking.most" type="button" data-testid="most-row" class="activity-row"
              [title]="row.companyName" (click)="select(row)">
        <span data-testid="activity-company-link" class="activity-row__name">{{ row.companyName }}</span>
        <span class="activity-row__track"><span class="activity-row__bar activity-row__bar--most" [style.width.%]="barWidth(row, ranking.most)"></span></span>
        <span data-testid="activity-value" class="activity-row__value">{{ formatValue(row) }}</span>
      </button>
    </div>
    <div class="activity-ranking__list">
      <p class="activity-ranking__label">Least active</p>
      <button *ngFor="let row of ranking.least" type="button" data-testid="least-row" class="activity-row"
              [title]="row.companyName" (click)="select(row)">
        <span data-testid="activity-company-link" class="activity-row__name">{{ row.companyName }}</span>
        <span class="activity-row__track"><span class="activity-row__bar activity-row__bar--least" [style.width.%]="barWidth(row, ranking.least)"></span></span>
        <span data-testid="activity-value" class="activity-row__value">{{ formatValue(row) }}</span>
      </button>
    </div>
  </div>
</div>
